import toastr from 'toastr'
import { toggleLoading } from '../utils/common'

const escapeHtml = (value) => {
  const element = document.createElement('div')
  element.textContent = value
  return element.innerHTML
}

const renderTagErrors = (errors) => {
  const tagErrors = document.getElementById('tag-errors')
  if (!tagErrors) return false

  const items = errors.map(error => `<li>${escapeHtml(error)}</li>`).join('')
  tagErrors.innerHTML = `<div class="inner"><strong>Article content saved, but some tags could not be saved.</strong><ul>${items}</ul></div>`
  tagErrors.style.display = ''
  tagErrors.classList.remove('fade-out')
  tagErrors.classList.add('fade-in')
  document.querySelector("[data-post-content-target='tagsInput']")?.focus()

  return true
}

const clearTagErrors = () => {
  const tagErrors = document.getElementById('tag-errors')
  if (!tagErrors) return

  tagErrors.innerHTML = ''
  tagErrors.style.display = 'none'
  tagErrors.classList.remove('fade-in')
  tagErrors.classList.add('fade-out')
}

export const useRedirectOnSuccess = (controller) => {
  Object.assign(controller, {
    onSend () {
      toggleLoading(document.body, true, 'Saving...')
    },
    onSuccess (event) {
      const [, , xhr] = event.detail
      const { status, response } = xhr

      try {
        const data = JSON.parse(response)
        clearTagErrors()

        // As error content is long and requires action from the editor
        // we will reload the page to show full flash message and not just a toastr
        if (data?.error) {
          toastr.error(`${data?.error}`)
          setTimeout(() => {
            window.location.href = window.location.href
          }, 5000)
        } else if (data?.tag_errors?.length) {
          renderTagErrors(data.tag_errors)
          toastr.warning('Article content saved. Some tags could not be saved.')
        } else {
          if (status === 200) {
            toastr.success('Changes saved successfully')
            if (data?.redirect_to) window.location.href = data.redirect_to
          } else {
            toastr.error('An error occurred while saving. Try again later.')
          }
        }
      } catch (e) {
        console.error('JSON Parse Error:', e)
        // If we can't parse JSON, assume it's HTML and reload the page
        window.location.href = window.location.href
      }
    },
    onComplete () {
      toggleLoading(document.body, true)
    },
  })
}
